// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1nNA4","content":"Layout_content__1t8Hf"};